import { APIProvider } from '@vis.gl/react-google-maps'

interface Props {
  children?: React.ReactNode
}
export const MapWrapper = ({ children }: Props) => {
  return <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!}>{children}</APIProvider>
}
